import { Injectable } from '@angular/core';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { HubTrucksModel } from '../../models';
import { HubTrucksState } from './hub-trucks.state';
import { HubTrucksInitialState, HubTrucksLoad, HubTrucksUpdate } from './hub-trucks.actions';

@Injectable({ providedIn: 'root' })
export class HubTrucksFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(HubTrucksState.getLoaded);
  trucks$: Observable<HubTrucksModel> = this.store.select(HubTrucksState.getTrucks);

  constructor(private store: Store) {}

  loadAll(hubId: string): void {
    this.store.dispatch(new HubTrucksLoad(hubId));
  }

  updateTrucks(hubId: number, hubTruckMapping: HubTrucksModel): void {
    this.store.dispatch(new HubTrucksUpdate({ hubId, hubTruckMapping }));
  }

  setInitialState(): void {
    this.store.dispatch(new HubTrucksInitialState());
  }
}
